import { FC, CSSProperties, useEffect, useState, memo } from "react";
import { Box } from "./Box";

const styles: CSSProperties = {
  display: "inline-block",
  position: "relative",
  // width: "300px",
};

const countBadgeStyles: CSSProperties = {
  position: "absolute",
  right: "-307px",
  top: "-8px",
  height: "35px",
  width: "35px",
  borderRadius: "50%",
  zIndex: 101,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#27CE0A",
  fontWeight: 700,
  fontFamily: "robotoregular",
  color: "white",
  fontSize: "25px",
};

export interface BoxDragPreviewProps {
  title?: string;
  blogItem?: any;
  count?: number;
}

export interface BoxDragPreviewState {
  tickTock: any;
}

export const BoxDragPreview: FC<BoxDragPreviewProps> = memo(function BoxDragPreview({ title, blogItem, count }) {
  return (
    <div style={styles}>
      {count && count > 1 ? <span style={countBadgeStyles}>{count}</span> : null}
      <Box preview blogItem={blogItem} count={count} />
      {count && count >= 2 ? <Box preview blogItem={blogItem} boxNumber={2} /> : null}
      {count && count >= 3 ? <Box preview blogItem={blogItem} boxNumber={3} /> : null}
    </div>
  );
});
